<template>
  <v-app class="main" v-scroll="onScroll">
    <app-main-navbar v-if="display"></app-main-navbar>
    <v-main>
      <router-view class=""></router-view>
      <v-fab-transition>
        <v-btn
          fab
          bottom
          small
          right
          color="primary"
          id="scroll__top"
          fixed
          v-if="showScrollToTop"
          @click="scrollToTop"
        >
          <v-icon dark> mdi-chevron-up </v-icon>
        </v-btn>
      </v-fab-transition>
      <!-- <Footer /> -->
    </v-main>
    <v-snackbar v-model="snackbar" :color="snackbarObj.color">
      {{ snackbarObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{ $t("common.close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <div>
      <v-dialog v-model="deleteDialog" max-width="450">
        <v-card class="custom-font">
          <v-card-title class="primary--text"></v-card-title>
          <v-card-text class="primary--text font-weight-bold">{{
            $t("common.delete")
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              class="font-weight-bold"
              small
              text
              @click="deleteDialog = false"
              >{{ $t("common.no") }}</v-btn
            >
            <v-btn
              color="error"
              class="font-weight-bold"
              small
              text
              :loading="deleteBtnLoading"
              @click="deleteItem()"
              >{{ $t("common.yesDelete") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="toggleDialog" max-width="450">
        <v-card class="pb-4">
          <v-card-title class="primary--text"></v-card-title>
          <v-card-text class=""> Do you want to change status ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              class="font-weight-bold"
              text
              @click="toggleDialog = false"
              >{{ $t("common.no") }}</v-btn
            >
            <v-btn
              color="error"
              class="font-weight-bold"
              text
              :loading="toggleBtnLoading"
              @click="toggleItem"
              >Yes, Change</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- <footer-bar
      v-if="isAuthenticated() && display"
      :style="
        `margin-left: ${
          !drawerState && !$vuetify.breakpoint.mdAndDown && !$vuetify.rtl ? '166px' : '0'
        };
        margin-right: ${
          !drawerState && $vuetify.rtl ? '166px' : '0'
        }`
      "
    /> -->
    <side-drawer v-if="$store.state.isAdminProfile">
      <template slot="formDetails">
        <customer-form />
      </template>
    </side-drawer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import goTo from "vuetify/lib/services/goto";
// import menuList from "@/core/components/menu";
import MainNavbar from "./core/components/MainNavbar.vue";
export default {
  data() {
    return {
      snackbar: false,
      snackbarObj: {},
      deleteDialog: false,
      toggleDialog: false,
      deleteDetails: {},
      showScrollToTop: false
      // navigationLists: menuList
    };
  },
  components: {
    "app-main-navbar": MainNavbar,
    // Footer: () => import("@/core/components/Footer"),
    "side-drawer": () => import("@/core/components/SideDrawer"),
    "customer-form": () =>
      import("@/core/components/rightSideDrawer/AdminProfile.vue")
    // "app-bar": () => import("@/core/components/AppBar")
  },
  mounted() {
    this.$root.$on("snackbar", data => {
      this.snackbar = data.snackbar;
      this.snackbarObj = {
        color: data.color,
        text: data.text
      };
    });
    this.$root.$on("deleteDialog", data => {
      this.deleteDialog = data.dialog;
      this.deleteDetails = data;
    });
    this.$root.$on("openAdminProfile", () => {
      let admin = JSON.parse(localStorage.getItem("DONE_USER"));
      this.$store.commit("IS_EDIT_CUSTOMER", true);
      this.$store.commit("EDIT_CUSTOMER", admin);
      this.$store.commit("IS_ADMIN_PROFILE", true);
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    });
    this.$root.$on("toggleDialog", data => {
      this.toggleDialog = data.dialog;
      this.toggleDetails = data;
    });
  },
  watch: {
    deleteBtnLoading: {
      handler() {
        if (!this.deleteBtnLoading) this.deleteDialog = false;
      },
      deep: true
    },
    toggleBtnLoading: {
      handler() {
        if (!this.toggleBtnLoading) this.toggleDialog = false;
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["drawerState", "deleteBtnLoading", "toggleBtnLoading"]),
    display() {
      var isVisible = false;
      const currentPath = this.$route.path;
      if (currentPath !== "/") {
        // debugger;
        this.$router.options.routes.forEach(element => {
          if (
            currentPath == element.path ||
            currentPath.includes("/payment/")
          ) {
            isVisible = true;
          } else if (element.children) {
            element.children.forEach(child => {
              // debugger;
              if (currentPath === "/landlord/" + child.path) {
                isVisible = true;
              }
              if (currentPath.includes("/landlord/details")) {
                isVisible = true;
              }
            });
          }
        });
      }
      return isVisible;
    }
  },
  methods: {
    isAuthenticated() {
      return localStorage.getItem("apollo-done-token") != null;
    },
    deleteItem() {
      this.$store.commit("DELETE_BTN_LOADING", true);
      this.$root.$emit("deleteItems", this.deleteDetails);
    },
    onScroll() {
      if (window.pageYOffset <= 0) this.showScrollToTop = false;
      else this.showScrollToTop = true;
    },
    scrollToTop() {
      goTo(0);
    },
    toggleItem() {
      this.$store.commit("TOGGLE_BTN_LOADING", true);
      this.$root.$emit("toggleItems", this.toggleDetails);
    }
  },
  apollo: {
    getAppConfiguration() {
      return {
        query: require("@/core/api/queries/get_app_configuration_query.graphql"),
        result({ data }) {
          this.$store.commit(
            "IMAGE_BASE_URL",
            data.getAppConfiguration.uploadS3Url
          );
          this.$store.commit("APP_CONFIGURATION", data.getAppConfiguration);
        }
      };
    }
  },
  beforeDestroy() {
    this.$root.$off("snackbar");
    this.$root.$off("deleteDialog");
    this.$root.$off("openAdminProfile");
    this.$root.$off("toggleDialog");
  }
};
</script>

<style>
.round-btn {
  border-radius: 20px !important;
}

.main {
  background-color: #f2f2f2 !important;
}

.v-data-table {
  border-radius: 10px !important;
}

.v-data-table-header {
  background-color: #f2f2f2ef;
}

.v-data-table-header th span {
  color: black;
}

.v-data-table tbody {
  background-color: #ffffff;
  letter-spacing: 0.1px;
}

.v-data-table tbody tr:nth-child(even) {
  background-color: #f2f2f2ef;
}

/* .v-data-table tbody tr td {
  background-color: #ffffff;
  letter-spacing: 0.1px;
  font-size: 13px !important; */
/* } */

.v-input_slot {
  border-radius: 10px;
}
.custom-button {
  color: white !important;
  background: #0075ff !important;
  border-radius: 47px !important;
}

.gadiant-color {
  background: -webkit-linear-gradient(
    left,
    rgb(0, 5, 97) 0%,
    rgb(0, 72, 126) 40%,
    rgb(0, 138, 154) 80%,
    rgb(0, 171, 168) 100%
  );
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: white !important;
}
.custom-btn {
  border: 2px solid #f8166c;
}
.icon,
.icon-remove {
  height: 30px;
  width: 30px;
}

.img-preview {
  width: 100px !important;
  width: auto;
}

#logo {
  display: none;
}
.v-text-field input::placeholder {
  font-size: 14px !important;
  font-weight: 700 !important;
}
.v-data-table-header th span {
  color: black;
  font-size: 0.875rem;
}
.v-label {
  font-size: 14px !important;
  font-weight: 700 !important;
}
.placeholder_as_label {
  font-size: 12px !important;
  font-weight: 700 !important;
}
</style>
